import "./Card.scss";
function Card({ imgSrc, number, title, lightColor, darkColor, underline }) {
  return (
    <div
      className="m-1 py-4 text-light d-flex justify-content-evenly align-items-center cards-numbers"
      style={{
        backgroundImage: `linear-gradient(to left, ${lightColor} , ${darkColor})`,
        borderRadius: "10px",
        height: "150px",
      }}
    >
      <div className="text-center">
        <div className="fs-5 mb-3">{title}</div>
        <div
          className={`${underline && "border-bottom"} border-3 d-inline fs-3`}
        >
          {number}
        </div>
      </div>
      <img src={`${imgSrc}`} style={{ height: "60px" }} />
    </div>
  );
}

export default Card;
